export default {
	config:{
		add:'Add',
		submit:'Submit',
		cancel:'Cancel',
		noData:'No data available',
		delete:'Delete',
		refresh:'Refresh',
		back:'Back',
		send:'Send',
		deleteMessage:'This operation will permanently delete the file, do you want to continue?',
		warnTitle:'Warn',
		success:'Submit Success!',
		warnFill:'Please fill',
		warnNumber:'Please enter a numeric value',
		warnInvalid:'Invalid fill',
		start:'Start',
		confirm:'Confirm',
		goto:'Please go to',
	},
	header:{
		changeLang:'Language',
		update:'Update',
		reset:'Reset',
		logout:'Logout',
	},
	welcome:{
		title:'Welcome to GreenPacket CPE',
		button:'Start',
		recommend:'Recommended installation location',
		recomText:'Before installing the equipment, it is recommended to perform signal quality testing to determine the optimal location.',
		next:'Next',
		parsing:'Analysis of installation steps',
		step1:'Step one',
		step1Text:'Bottom of the fuselage, confirm the card',
		step2:'Step two',
		step2Text:'Metal cover, screw into the card slot',
		step3:'Step three',
		step3Text:'Tighten the cover, waterproof and dustproof',
		step4:'Step four',
		step4Text:'Network cable insertion, sealing ferrule',
		step5:'Step five',
		step5Text:'Tighten the ferrule, waterproof and safe',
		step6:'Step six',
		step6Text:'The back of the fuselage, insert the hose clamp',
		step7:'Step seven',
		step7Text:'Buckle into the holding pole, tighten and fix',
		step8:'Step eight',
		step8Text:'Adjust the angle and complete the installation',
		find:'Adjust the position and direction of the router to find the best signal.',
		nowSignal:'Current signal quality',
		score:'Score',
		suggest:'Excellent signal.Use this location and angle.',
		continue:'Keep Testing',
		signalStrength:'Signal strength',
		distributed:'Detection record distribution',
		guide:'Internet guide',
		guideSsid:'SSID',
		guidePsw:'Wi-Fi password',
		samePsw:'Set device password',
		sameText:'Same as Wi-Fi password',
		oldPsw:'Old password',
		newPsw:'New password',
		passwordRuleText:'Password rules: 8-20 digits password, must contain uppercase and lowercase letters,numbers and special characters',
		rules:{
			pwdMust:'Password must',
			pwdRule:'Password does not meet the rules',
		},
		finish:'Finish',
		resetWait:'The device is restarting … Please wait',
		newWlanName:'The new Wi-Fi name is：',
		reloadPage:'You can change device settings by visiting this website again',
	},
	login:{
		userName:'User name',
		userPassword:'User password',
		loginBtn:'Login',
		forgetPsw:'Forget password',
		resetText:'Please long press the RESET button to restore the factory settings (may cause your user data to be lost), and reset the password.',
	},
	menu:{
		home:'Home',
		mobilenet:'Mobile Network',
		easy:'Wi-Fi Basic Setting',
		terminal:'Devices',
		tools:'Tools',
		sms:'SMS',
		settings:'Advanced',
		advanced:{
			DeviceInformation:'Device Information',
			NetworkMenu:{
				Network:'Network',
				APNManagement:'APN Management',
				DHCPSettings:'DHCP Settings',
				LTEConfiguration:'LTE Configuration',
				CellSelection:'Cell Selection',
				LockBand:'Lock Band',
				NetworkSelection:'Network Selection',
				CommandShell:'Command Shell',
			},
			WiFiMenu:{
				WiFi:'Wi-Fi',
				WLANStatus:'WLAN Status',
				WLANSettings:'WLAN Settings',
				WPS:'WPS',
				MACFILTER:'MAC FILTER',
			},
			FirewallMenu:{
				Firewall:'Firewall',
				FirewallSettings:'Firewall Settings',
				ALG:'ALG',
				PortForwarding:'Port Forwarding',
				DMZsettings:'DMZ settings',
				UPnP:'UPnP',
				IPFiltering:'IP Filtering',
				URLFiltering:'URL Filtering',
				PortFiltering:'Port Filtering',
			},
			SystemMenu:{
				System:'System',
				Maintenance:'Maintenance',
				DDNS:'DDNS',
				General:'General',
				Ping:'Ping',
				Update:'Update',
				TR069:'TR069',
				Iperf:'Iperf',
			},
			VoiceMenu:{
				VoiceSettings:'Voice Settings',
				SIPSever:'SIP Server',
				DigitalMap:'Digital Map',
			}
		}
	},
	home:{
		netStatusYes:'Network connected',
		netStatusNo:'Network not connected',
		myDevice:'My device',
		devices:'Connect devices',
		moreInternet:'More network settings',
		moreInfo:'More device information',
		moreDevices:'Terminal management',
	},
	mobileNetwork:{
		pageConnect:'Internet Connection',
		pageConnectInfo:{
			text:'The access point name (APN) is the name of the setting information read by your device, which is used to set up the connection with the network management between the mobile network of the operator and the public network. In most cases, your device has made these settings in the system file, and you can automatically fill in the APN information in the link.',
			apnName:'APN Name',
			classId:'Class ID',
			IpType:'IP Type',
			auth:'Auth',
			username:'Username',
			password:'Password',
			up32:'Up to 32 characters',
			up64:'Up to 64 characters',
			MaxLimit:'Max Limit:16',
			None:'None',
		},
		pageSearch:'Mobile Network Searching',
		pageSearchInfo:{
			text:'The device supports "Smart Internet", automatically selects a better network, and has a better Internet experience',
			NetworkingMode:'Networking mode',
			InternetSearchMethod:'Internet search method',
		},
		search:'Auto',
	},
	myDevicesInfo:{
		SystemInfomation:'System Infomation',
		VersionInfomation:'Version Infomation',
		LANStatus:'LAN Status',
		RunningTime:'Running Time',
		ProductModel:'Product Model',
		HardwareVersion:'Hardware Version',
		SoftwareVersion:'Software Version',
		SerialNumber:'Serial Number',
		MACAddress:' MAC Address',
		WanIP:'WAN IP Address',
		IPAddress:'IP Address',
		SubnetMask:'Subnet Mask',
	},
	devicesManage:{
		title:'Terminal management',
		text:'Display and manage all terminal information',
		WiFiStatus:'WiFi Status',
		Frequency:'Frequency(Channel)',
		SecurityMode:'Security Mode',
		DeviceList:'Device List',
		onlineTable:'Online terminal',
		outlineTable:'Offline terminal',
		allowNet:'Allow internet',
		stopTime:'Lease expiry time',
		editName:'Edit Name',
		deleteText:'Are you sure to delete the current device',
	},
	easyWlan:{
		title:'Wi-Fi easy setup',
		text:'Quickly modify Wi-Fi SSID and password',
		first5G:'5G Prefer',
		first5GMessage:'When both 2.4G and 5G WiFi signal are displayed together at the same time, 5G will be the preffered signal as it is the faster connection under the same signal stregth condition. In order to adjust 2.4G and 5Ghz seperately, kindly disable the toggle that display both wifi signal at the sametime. ',
		SSID:'SSID',
		SecurityPolicy:'Security Policy',
		SecurityMode:'Security Mode',
		WPAOption:'WPA Option',
		Passwordrules:{
			PasswordrulesText:'Password rules',
			UserNamerulesText:'SSID rules',
			rules1:'The string length in WEP mode is 5 or 13 digits.',
			rules2:'In other modes, the string is limited to 8-32 bits.',
			rules3:'Please enter a password of 5 or 13 length,Please fill in the qualified value.',
			rules4:'Please enter a password of 8-32 length,Please fill in the qualified value.',
			rules5:'Only allow input  A-Z，a-z, 0-9,  special character.',
			rules6:'The string length is linited to 1-32 digits.',
			warnMessage:'Changing a setting will cause the Wi-Fi to be temporarily disconnected and you may lose your connection.If this happenses,please reconnect Wi-Fi and refresh this page.',
			successMessage:'Configure Success,Please reconnect using your new wifi credentials.'
		}
	},
	sms:{
		inbox:'Inbox',
		outbox:'Outbox',
		settings:'Settings',
		newMessage:'New Message',
		phoneNumber:'Number',
		content:'Content',
		date:'Date',
		time:'Time',
		Recipient:'Recipient',
		RemainingWords:'Remaining Words',
		sender:'Sender',
		smsCenterNumber:'SMS Center Number',
		warnLimit:'Length exceeds limit',
		warnFill:'Please fill out and submit',
		warnNumber:'Please fill in the SMS center number',
	},
	dhcpSettings:{
		LANHostSettings:'LAN Host Settings',
		LocalIPAddress:'Local IP Address',
		SubnetMask:'Subnet Mask',
		LANDHCPSettings:'LAN DHCP Settings',
		DHCPServer:'DHCP Server',
		StartIP:'Start IP',
		EndIP:'End IP',
		LeaseTime:'Lease Time(s)',
		StaticRouteSettings:'Static Route Settings',
		Index:'Index',
		DestinationIP:'Destination IP',
		RouteSubnetMask:'Route Subnet Mask',
		Gateway:'Gateway',
		warnIp1:'Local IP address is invalid',
		warnSubnetMask:'Subnet Mask is invalid',
		warnStartIp:'Please enter an integer greater than 0 and less than or equal to 255',
		warnEndIp:'End IP must be greater than or equal to Start IP',
		warnTime:'Please fill in the qualified value',
	},
	CellSelection:{
		Priority:'Priority',
		NetworkMode:'Network Mode',
	},
	LockBand:{
		TechnologyModeSetting:'Technology Mode Setting',
	},
	CommandShell:{
		CommandRunningResults:'Command Running Results',
		Command:'Command',
		warnEmpty:'Command cannot be empty',
	},
	WLANStatus:{
		APInformation:'AP Information',
		SSID:'SSID',
		TxPower:'Tx Power',
		Mode:'Mode',
		Channel:'Channel',
		ChannelBandwidth:'Channel Bandwidth',
		Rates:'Rates',
		Security:'Security',
	},
	WLANSettings:{
		BasicSettings:'Basic Settings',
		Name:'Name',
		WLAN:'WLAN',
		SSID:'SSID',
		CountryCode:'Country Code',
		Mode:'Mode',
		ChannelBandwidth:'Channel Bandwidth',
		ChannelMode:'Channel Mode',
		Channel:'Channel',
		TxPower:'Tx Power',
		MaxSTAs:'Max STAs',
		MaxLength:'Max Length',
	},
	WLANWps:{
		settings:'Settings',
		WPSMode:'WPS Mode',
	},
	MacFilter:{
		nodeTitle:'MAC Filter',
		MACFilterMode:'MAC Filter Mode',
		WLANAccessList:'WLAN Access List',
		warnEmpty:'This Mac address cannot be empty',
		warnAddress:'This Mac address does not meet the standard',
		whitelist:'White List',
		blacklist:'Black List',
	},
	FirewallSettings:{
		FirewallProtection:'Firewall Protection',
		SPIFirewall:'SPI Firewall',
		BlockWANRequests:'Block WAN Requests',
		BlockAnonymousInternetRequests:'Block Anonymous Internet Requests',
		FilterIDENT:'Filter IDENT(Port 113)',
	},
	Alg:{
		IPSecPassthrough:'IPSec Passthrough',
		L2TPPassthrough:'L2TP Passthrough',
		PPTPPassthrough:'PPTP Passthrough',
		FTPPassthrough:'FTP Passthrough',
		H323Passthrough:'H323 Passthrough',
		SIPPassthrough:'SIP Passthrough',
		RTSPPassthrough:'RTSP Passthrough',
	},
	PortForwarding:{
		PortForwardingList:'Port Forwarding List',
		Application:'Application',
		PortFrom:'Port From',
		Protocol:'Protocol',
		IPAddress:'IP Address',
		PortTo:'Port To',
		Enable:'Enable',
		Disable:'Disable',
		Both:'Both',
	},
	Dmz:{
		DMZEnableStatus:'DMZ Enable Status',
		DMZHostIPAddress:'DMZ Host IP Address',
		ExcludeWebServerPort:'Exclude Web Server Port',
		ExcludeTelnetSSHPort:'Exclude Telnet/SSH Port',
		ExcludePingService:'Exclude Ping Service',
	},
	Upnp:{
		UPnPConfiguration:'UPnP Configuration',
		UPnPService:'UPnP Service',
		UPnPNotificationInterval:'UPnP Notification Interval',
		DeleteAll:'Delete All',
	},
	IPFiltering:{
		IPFilter:'IP Filter',
		EnableIPFilter:'Enable IP Filter',
		message:'he function to filter IP addresses in the wireless local area network [WLAN],it can be used to restrict the user access to the specific internet services.',
		warnIp:'IP address is invalid',
		maxLimit10:'Max Limit:10',
		empty:'This IP address cannot be empty',
		standard:'This IP address does not meet the standard',
	},
	URLFiltering:{
		URLFilter:'URL Filter',
		EnableURLFilter:'Enable URL Filter',
		message:'The function to filter URL in the wireless local area network [WLAN],it can be used to restrict the user access to the specific internet services.',
		maxLimit10:'Max Limit:10',
	},
	PortFiltering:{
		PortFilter:'Port Filter',
		EnablePortFilter:'Enable Port Filter',
		message:'The function to filter Port in the wireless local area network [WLAN],it can be used to restrict the user access to the specific internet services.',
		maxLimit10:'Max Limit:10',
		PortStart:'Port Start',
		PortEnd:'Port End',
	},
	Maintenance:{
		Reboot:'Reboot',
		RebootText:'Click Reboot to reboot device',
		FactoryReset:'Factory Reset',
		FactoryResetText:'Click Factory Reset to restore device to its factory settings',
		FactoryResetWarn:'Click the Factory Reset button to reset',
		Syslog:'Syslog',
		Download:'Download',
		Backup:'Backup Configuration File',
		BackupText:'To backup the current configuration file,click Download',
		Restore:'Restore Configuration File',
		RestoreText:'To restore the configuration file,specify the path of the local congiguration file,import the file,and click Upload to restore the configuration file',
		Upload:'Upload',
	},
	DDNS:{
		DDNSService:'DDNS Service',
		UserName:'User Name',
		Password:'Password',
		HostName:'Host Name',
		Status:'Status',
		InternetIPAddress:'Internet IP Address',
	},
	General:{
		ChangePassword:'Change Password',
		OldPassword:'Old Password',
		NewPassword:'New Password',
		Passwordrules:'Password rules: 8-20 digits password, must contain uppercase and lowercase letters, numbers and special characters',
		ReentertoConfirm:'Re-enter to Confirm',
		TimeSettings:'Time Settings',
		NTPEnableStatus:'NTP Enable Status',
		TimeZone:'Time Zone',
		SummerTimeEnable:'Summer Time Enable',
		NTPServer:'NTP Server',
		UseLocalHostTime:'Use Local Host Time',
		RefreshInterval:'Refresh Interval',
		minutes:'minutes',
		AutoRefresh:'Auto-Refresh',
		rePasswordMust:'New password again',
		passwordSame:'The two password inputs are inconsistent!',
	},
	Ping:{
		PingTest:'Ping Test',
		IPProtocol:'IP Protocol',
	},
	Update:{
		LocalFirmwareUpdate:'Local Firmware Update',
		LocationText:'Location',
		ChooseFile:'Choose File',
	},
	systemTr:{
		ACSURL:'ACS URL',
		ACSUserName:'ACS User Name',
		ACSUserPassword:'ACS User Password',
		PeriodicInform:'Periodic Inform',
		PeriodicInformInterval:'Periodic Inform Interval',
		PeriodicInformTime:'Periodic Inform Time',
		RequestUserName:'Request User Name',
		RequestUserPassword:'Request User Password',
	},
	Iperf:{
		IperfSettings:'Iperf Settings',
		Status:'Status',
		ServerAddress:'Server Address',
		ServerPort:'Server Port',
		ManagementPort:'Management Port',
		MeasurementTime:'Measurement Time',
		Seconds:'Seconds',
		ProtocolType:'Protocol Type',
		WindowSize:'Window Size',
		TCPClientNumber:'TCP Client Number',
		DataLength:'Data Length',
		UDPBandwidth:'UDP Bandwidth',
		UplinkSpeed:'Uplink Speed',
		DownlinkSpeed:'Downlink Speed',
		UplinkLatency:'Uplink Latency',
		DownlinkLatency:'Downlink Latency',
	},
	VoiceSettings:{
		RegisterStatus:'VoIP Register Status',
		AuthorizationSatus:'Authorization Satus',
		RegServer:'Reg Server',
		Address:'Address',
		Port:'Port',
		SIPDomain:'SIP Domain',
		Domain:'Domain',
		SIPProxy:'SIP Proxy',
		Enable:'Enable',
		Authorization:'Authorization',
		AuthName:'Auth Name',
		PhoneName:'Phone Name',
		RegAccount:'Reg Account',
		RegPassword:'Reg Password',
	},
	DialtalMap:{
		DialPlan:'Dial Plan',
	}
}
